module.exports = __webpack_public_path__ + "static/media/conference-catering-3.a5ffe2ee.jpg";